import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/layout'

/** note: 子菜单只在children.length>=1时出现
 *  细节见  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   如果' hidden:true '不会显示在侧边栏中(默认为false)
* alwaysShow: true               如果设置为true，将始终显示根菜单，无论其子路由长度如何
*                                如果不经常设置show，只能有一条以上的路由下的孩子
*                                它将成为嵌套模式，否则不显示根菜单
* redirect: noredirect           如果“重定向:noredirect”不会在面包屑中重定向
* name:'router-name'             如果“redirect:noredirect”在面包屑中没有重定向，则<keep-alive>(必须设置!!)
* meta : {
    role: ['admin','editor']     将控制页面角色(您可以设置多个角色)
    perms: ['GET /aaa','POST /bbb']     将控制页面角色(可以设置多个角色)
    title: 'title'               子菜单和面包屑中显示的名称(推荐集)
    icon: 'iconfont'             侧边栏中显示的图标，
    noCache: true                如果为真，页面将不会被缓存(默认为false)
    breadcrumb: false            如果设置为false，则不会在breadcrumb面包屑中显示
  }
 ** 路由结构 **
  {
    path: '/nested',
    component: Layout,
    alwaysShow: true,
    redirect: '/nested/menu1',
    name: 'Nested',
    meta: {
      title: '一级',
      icon: 'nested'
    },
    children: [
      {
        path: 'menu1',
        component: () => import('@/views/nested/menu1/index'),
        name: 'Menu1',
        alwaysShow: true,
        meta: { title: '二级' },
        children: [
          {
            path: 'menu1-1',
            component: () => import('@/views/nested/menu1/menu1-1'),
            name: 'Menu1-1',
            meta: { title: '二级-1' }
          },
          {
            path: 'menu1-2',
            component: () => import('@/views/nested/menu1/menu1-2'),
            name: 'Menu1-2',
            meta: { title: '二级-2' }
          }
        ]
      }
    ]
  }
**/
export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //history路由需要服务支持
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {//首页
    path: '/',
    component: Layout,
    redirect: 'dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { 
          perms: [
            'index',
            'statistics/index', 
            'statistics/shortcutmenu', 
            'statistics/housingbrief', 
            'statistics/personalsalesbriefing',
            'statistics/add',
            'statistics/deal',
            'statistics/personalranking',
            'statistics/departmentranking',
            'statistics/customerfunnel',
            'statistics/systemnotification'
          ],
          title: '首页',
          icon: 'iconfont iconshouye', 
          noCache: true 
        }
      },
      {
        path: 'notice-info',
        component: () => import('@/views/operation/content/notice/notice-info'),
        name: 'noticeInfo',
        meta: {
          // perms: ['operate.notice/info'],
          title: '查看公告',
          noCache: true,
          guidePath:true,
          jumpPath:'/operation/content/notice-list'
        },
        hidden: true
      },
    ]
  },
  {//用户管理
    path: '/user',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    name: 'userManage',
    meta: {
      title: '用户',
      icon: 'iconfont iconyonghu1'
    },
    children: [
      {
        path: 'register-user',
        component: () => import('@/views/user/register-user'),
        name: 'registerUser',
        meta: {
          perms: ['user.register/index'],
          title: '注册用户',
          noCache: true
        },
      },
      {
        path: 'leavephone-user',
        component: () => import('@/views/user/leavephone-user'),
        name: 'leavephoneUser',
        meta: {
          perms: ['user.phone/index','user.phone/edit','user.phone/info'],
          title: '留电用户',
          noCache: true
        }
      },
      {
        path: 'leavephone-info',
        component: () => import('@/views/user/leavephone-info'),
        name: 'leavephoneInfo',
        meta: {
          perms: ['user.phone/info'],
          title: '用户信息',
          noCache: true,
          guidePath:true,
          jumpPath:'/user/leavephone-user'
        },
        hidden: true
      },
    ]
  },
  {//客户[CRM]
    path: '/customer',
    component: Layout,
    alwaysShow: true,
    redirect: '/customer/material',
    name: 'customerManage',
    meta: {
      title: '客户[CRM]',
      icon: 'iconfont iconkehu'
    },
    children: [
      {
        path: 'material',
        component: () => import('@/views/customer/index'),
        name: 'Material',
        alwaysShow: true,
        meta: {
          perms: ['customer.management'],
          title: '客户管理'
        },
        children: [
          {
            path: 'material-list',
            component: () => import('@/views/customer/material/material-list'),
            name: 'materialList',
            meta: {
              title: '客户列表',
              perms: [
                'customer.strategy.pri',
                'customer.strategy.pri/info',
                'customer.strategy.pri/searchcustomer',
                'customer.strategy.pri/resetsearch',
                'customer.strategy.pri/addcustomer',
                'customer.strategy.pri/repeat',
                'customer.strategy.pri/batchtransfer',
                'customer.strategy.pri/batchtransfersea',
                'customer.strategy.pri/addfollow',
              ]
            }
          },
          {
            path: 'material-add',
            component: () => import('@/views/customer/material/material-add'),
            name: 'materialAdd',
            meta: {
              perms: ['customer.strategy.pri/addcustomer'],
              title: '添加客户',
              noCache: true,
              guidePath:true,
              jumpPath:'/customer/material/material-list'
            },
            hidden: true
          },
          {
            path: 'material-info',
            component: () => import('@/views/customer/material/material-info'),
            name: 'materialInfo',
            meta: {
              perms: [
                'customer.strategy.pri/info',
                'customer.strategy.pri/infotransfer',
                'customer.strategy.pri/infotransfersea',
                'customer.strategy.pri/addcontacts',
                'customer.strategy.pri/editcontacts',
                'customer.strategy.pri/adddemand',
                'customer.strategy.pri/editdemand',
                'customer.strategy.pri/showdemand',
                'customer.strategy.pri/customeredit',
                'customer.strategy.pri/customershow',
                'customer.strategy.pri/clearcontacts',
                'customer.strategy.pri/repeat',
                'customer.strategy.pri/customershow',
                'customer.strategy.pri/customeredit',
                'customer.strategy.pri/addcollaborator',
                'customer.strategy.pri/showtransfer',
                'customer.strategy.pri/showfollowlist',
                'customer.strategy.pri/editfollow',
                'customer.strategy.pri/updatecustomerstate',
                'customer.strategy.pri/contractadd',
                'customer.strategy.pri/addvip',
                'customer.strategy.pri/contractlist',
                'customer.strategy.pri/contractedit',
                'customer.strategy.pri/contractinfo',
                'customer.strategy.pri/phoneuserinfo',
                'customer.strategy.pri/forminfo'
              ],
              title: '查看客户详情',
              noCache: true,
              guidePath:true,
              jumpPath:'/customer/material/material-list'
            },
            hidden: true
          },
          {
            path: 'public-list',
            component: () => import('@/views/customer/public/public-list'),
            name: 'publicList',
            meta: {
              perms: [
                'customer.strategy.pub',
                'customer.strategy.pub/searchcustomer',
                'customer.strategy.pub/batchtransfer',
                'customer.strategy.pub/batchtapcustomer',
                'customer.strategy.pub/showcustomer',
                'customer.strategy.pub/addfollow',
                'customer.strategy.pub/tapcustomer'
              ],
              title: '客户公海'
            }
          },
          {
            path: 'public-add',
            component: () => import('@/views/customer/public/public-add'),
            name: 'publicAdd',
            meta: {
              perms: ['customer.strategy.pub/addcustomer'],
              title: '添加公客',
              noCache: true,
              guidePath:true,
              jumpPath:'/customer/material/public-list'
            },
            hidden: true
          },
          {
            path: 'public-info',
            component: () => import('@/views/customer/public/public-info'),
            name: 'publicInfo',
            meta: {
              perms: [
                'customer.strategy.pub/showcustomer',
                'customer.strategy.pub/infotransfercustomer',
                'customer.strategy.pub/showtransfer',
                'customer.strategy.pub/tapcustomer',
                'customer.strategy.pub/showcontact',
                'customer.strategy.pub/infoshow',
                'customer.strategy.pub/addfollow',
                'customer.strategy.pub/editfollow',
                'customer.strategy.pub/showfollowlist',
                'customer.strategy.pub/showdemand',
                'customer.strategy.pub/contractlist',
                'customer.strategy.pub/contractinfo',
                'customer.strategy.pub/phoneuserinfo',
                'customer.strategy.pub/forminfo'
              ],
              title: '查看客户公海详情',
              noCache: true,
              guidePath:true,
              jumpPath:'/customer/material/public-list'
            },
            hidden: true
          }
        ]
      },
      {//客户策略
        path: '/strategy',
        component: () => import('@/views/customer/index'),
        alwaysShow: true,
        name: 'strategyManage',
        meta: {
          perms: ['customer.strategy'],
          title: '客户策略',
        },
        children: [
          {
            path: 'customer-recovery',
            component: () => import('@/views/customer/strategy/customer-recovery'),
            name: 'customerRecovery',
            meta: {
              perms: ['customer.strategy/showsea','customer.strategy/editsea'],
              title: '客户公海回收策略',
              noCache: true
            },
          },
          {
            path: 'customer-security',
            component: () => import('@/views/customer/strategy/custormer-security'),
            name: 'customerSecurity',
            meta: {
              perms: ['customer.strategy/safe','customer.strategy/editsafe'],
              title: '客户安全策略',
              noCache: true
            }
          },
          {
            path: 'customer-distribution',
            component: () => import('@/views/customer/strategy/customer-distribution'),
            name: 'customerDistribution',
            meta: {
              perms: ['customer.strategy/recover','customer.strategy.recover/list','customer.strategy.recover/add','customer.strategy.recover/edit','customer.strategy.recover/button'],
              title: '自动分配策略',
              noCache: true
            }
          },
        ]
      },
      {//客户池
        path: 'pool',
        component: () => import('@/views/customer/pool/customer-pool'),
        name: 'poolManage',
        meta: {
          title: '客户池',
          perms: [
            'customer.pool',
            'customer.pool/list',
            'customer.pool/search',
            'customer.pool/customerpoolfield',
            'customer.pool/import',
            'customer.pool/repeat',
            'customer.pool/addpool',
            'customer.pool/editpool',
            'customer.pool/batheditstate',
            'customer.pool/importlist',
            'customer.pool/translist',
            'customer.pool/recoverlist',
            'customer.pool/export'
          ],
        }
      },
      {
        path: 'import-record',
        component: () => import('@/views/customer/pool/import-record'),
        name: 'importRecord',
        meta: {
          perms: ['customer.pool/importlist','customer.pool/downloadenclosure'],
          title: '导入记录',
          noCache: true,
          guidePath:true,
          jumpPath:'/customer/pool'
        },
        hidden: true
      },
    ]
  },
  {//合同管理
    path: '/contract',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    name: 'contractManage',
    meta: {
      title: '合同管理',
      icon: 'iconfont iconhetong3'
    },
    children: [
      {
        path: 'contract-list',
        component: () => import('@/views/contract/contract-list'),
        name: 'auctionList',
        meta: {
          // perms: ['customer.contract/index','contract/list','contract/search','contract/add','contract/addvip','contract/info'],
          perms: ['customer.contract/list'],
          title: '合同列表',
          noCache: true
        },
      },
      {
        path: 'contract-info',
        component: () => import('@/views/contract/contract-info'),
        name: 'contractInfo',
        meta: {
          perms: ['customer.contract/info','contract/edit','contract/transfer'],
          title: '合同详情',
          noCache: true,
          guidePath:true,
          jumpPath:'/contract/contract-list'
        },
        hidden: true
      },
    ]
  },
  {//拍卖成交管理
    path: '/auction',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    name: 'auctionManage',
    meta: {
      title: '拍卖成交管理',
      icon: 'iconfont iconpaimai'
    },
    children: [
      {
        path: 'auction-list',
        component: () => import('@/views/auction/auction-list'),
        name: 'auctionList',
        meta: {
          perms: ['dealmanage/list','dealmanage/search','dealmanage/add','dealmanage/info','dealmanage/edit'],
          title: '拍卖成交列表',
          noCache: true
        },
      },
      {
        path: 'auction-add',
        component: () => import('@/views/auction/auction-add'),
        name: 'auctionAdd',
        meta: {
          perms: ['dealmanage/add'],
          title: '添加拍卖成交',
          noCache: true,
          guidePath:true,
          jumpPath:'/auction/auction-list'
        },
        hidden: true
      },
      {
        path: 'auction-edit',
        component: () => import('@/views/auction/auction-add'),
        name: 'auctionEdit',
        meta: {
          perms: ['dealmanage/edit'],
          title: '编辑拍卖成交',
          noCache: true,
          guidePath:true,
          jumpPath:'/auction/auction-list'
        },
        hidden: true
      },
      {
        path: 'auction-info',
        component: () => import('@/views/auction/auction-info'),
        name: 'auctionInfo',
        meta: {
          perms: ['dealmanage/info','dealmanage/addfollow','dealmanage/editfollow'],
          title: '拍卖成交详情',
          noCache: true,
          guidePath:true,
          jumpPath:'/auction/auction-list'
        },
        hidden: true
      },
    ]
  },
  {//房源
    path: '/housing',
    component: Layout,
    alwaysShow: true,
    redirect: '/housing/community',
    name: 'housingManage',
    meta: {
      title: '房源',
      icon: 'iconfont iconfang'
    },
    children: [
      {
        path: 'busicircle',
        component: () => import('@/views/housing/index'),
        name: 'Busicircle',
        alwaysShow: true,
        meta: {
          perms: ['house.busicircle/index'],
          title: '商圈管理'
        },
        children: [
          {
            path: 'busicircle-list',
            component: () => import('@/views/housing/busicircle/busicirclelist/busicircle-list'),
            name: 'busicircleList',
            meta: {
              perms: ['house.busicircle/list','house.busicircle/add','house.busicircle/edit','house.busicircle/info'],
              title: '商圈列表'
            }
          },
          {
            path: 'busicircle-add',
            component: () => import('@/views/housing/busicircle/busicirclelist/busicircle-add'),
            name: 'busicircleAdd',
            meta: {
              perms: ['house.busicircle/add'],
              title: '添加商圈',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/busicircle/busicircle-list'
            },
            hidden: true
          },
          {
            path: 'busicircle-edit',
            component: () => import('@/views/housing/busicircle/busicirclelist/busicircle-add'),
            name: 'busicircleEdit',
            meta: {
              perms: ['house.busicircle/edit'],
              title: '编辑商圈',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/busicircle/busicircle-list'
            },
            hidden: true
          },
          {
            path: 'busicircle-info',
            component: () => import('@/views/housing/busicircle/busicirclelist/busicircle-info'),
            name: 'busicircleInfo',
            meta: {
              perms: ['house.busicircle/info'],
              title: '查看商圈',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/busicircle/busicircle-list'
            },
            hidden: true
          },
        ]
      },
      {
        path: 'community',
        component: () => import('@/views/housing/index'),
        name: 'Community',
        alwaysShow: true,
        meta: {
          perms: ['house.village/index'],
          title: '小区管理'
        },
        children: [
          {
            path: 'community-list',
            component: () => import('@/views/housing/community/communitylist/community-list'),
            name: 'communityList',
            meta: {
              perms: ['house.village/list','house.village/add','house.village/edit','house.village/search','house.village/info','house.village/infoimg','house.village/addimg','house.village/editimg'],
              title: '小区列表'
            }
          },
          {
            path: 'community-add',
            component: () => import('@/views/housing/community/communitylist/community-add'),
            name: 'communityAdd',
            meta: {
              perms: ['house.village/add'],
              title: '添加小区',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/community/community-list'
            },
            hidden: true
          },
          {
            path: 'community-edit',
            component: () => import('@/views/housing/community/communitylist/community-add'),
            name: 'communityEdit',
            meta: {
              perms: ['house.village/edit'],
              title: '编辑小区',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/community/community-list'
            },
            hidden: true
          },
          {
            path: 'community-info',
            component: () => import('@/views/housing/community/communitylist/community-info'),
            name: 'communityInfo',
            meta: {
              perms: ['house.village/info'],
              title: '查看小区',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/community/community-list'
            },
            hidden: true
          },
          {
            path: 'community-add-photo',
            component: () => import('@/views/housing/community/communitylist/community-add-photo'),
            name: 'communityAddPhoto',
            meta: {
              perms: ['house.village/addimg'],
              title: '添加小区相册',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/community/community-list'
            },
            hidden: true
          },
          {
            path: 'community-edit-photo',
            component: () => import('@/views/housing/community/communitylist/community-add-photo'),
            name: 'communityEditPhoto',
            meta: {
              perms: ['house.village/editimg'],
              title: '编辑小区相册',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/community/community-list'
            },
            hidden: true
          },
          {
            path: 'community-info-photo',
            component: () => import('@/views/housing/community/communitylist/community-info-photo'),
            name: 'communityInfoPhoto',
            meta: {
              perms: ['house.village/infoimg'],
              title: '查看小区相册',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/community/community-list'
            },
            hidden: true
          },
        ]
      },
      {
        path: 'foreclosure',
        component: () => import('@/views/housing/index'),
        name: 'Foreclosure',
        alwaysShow: true,
        meta: {
          perms: ['house.fapaifang/index'],
          title: '拍卖房'
        },
        children: [
          {
            path: 'house-list',
            component: () => import('@/views/housing/foreclosure/houselist/house-list'),
            name: 'houseList',
            meta: {
              perms: ['house.beijing/list',,'house.beijing/updown','house.beijing/batchsend', 'house.beijing/housefield', 'house.beijing/export','house.beijing/search','house.beijing/recomm','house.beijing/copyhouse','house.beijing/multiplexing','house.beijing/add','house.beijing/addimg','house.beijing/adddiligencing','house.beijing/info','house.beijing/infoimg','house.beijing/infodiligencing','house.beijing/edit','house.beijing/editimg'],
              title: '房源列表'
            }
          },
          {
            path: 'house-add',
            component: () => import('@/views/housing/foreclosure/houselist/house-add'),
            name: 'houseAdd',
            meta: {
              perms: ['house.beijing/add'],
              title: '新增房源',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'house-edit',
            component: () => import('@/views/housing/foreclosure/houselist/house-add'),
            name: 'houseEdit',
            meta: {
              perms: ['house.beijing/edit'],
              title: '编辑房源',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'house-info',
            component: () => import('@/views/housing/foreclosure/houselist/house-info'),
            name: 'houseInfo',
            meta: {
              perms: ['house.beijing/info'],
              title: '查看房源',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'house-hx',
            component: () => import('@/views/housing/foreclosure/houselist/house-hx'),
            name: 'houseInfo',
            meta: {
              perms: ['house.beijing/edithx'],
              title: '修改户型朝向楼层',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'survey-add',
            component: () => import('@/views/housing/foreclosure/houselist/survey-info'),
            name: 'surveyAdd',
            meta: {
              perms: ['house.beijing/adddiligencing'],
              title: '添加尽调',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'survey-info',
            component: () => import('@/views/housing/foreclosure/houselist/survey-info'),
            name: 'surveyInfo',
            meta: {
              perms: ['house.beijing/infodiligencing'],
              title: '查看尽调',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'house-add-photo',
            component: () => import('@/views/housing/foreclosure/houselist/house-add-photo'),
            name: 'houseAddPhoto',
            meta: {
              perms: ['house.beijing/addimg'],
              title: '添加房产相册',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'house-edit-photo',
            component: () => import('@/views/housing/foreclosure/houselist/house-add-photo'),
            name: 'houseEditPhoto',
            meta: {
              perms: ['house.beijing/editimg'],
              title: '编辑房产相册',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
          {
            path: 'house-info-photo',
            component: () => import('@/views/housing/foreclosure/houselist/house-info-photo'),
            name: 'houseInfoPhoto',
            meta: {
              perms: ['house.beijing/infoimg'],
              title: '查看房产相册',
              noCache: true,
              guidePath:true,
              jumpPath:'/housing/foreclosure/house-list'
            },
            hidden: true
          },
        ]
      }
    ]
  },
  // {//日历管理
  //   path: '/calendar',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   alwaysShow: true,
  //   name: 'calendarManage',
  //   meta: {
  //     title: '日历',
  //     icon: 'iconfont iconrili'
  //   },
  //   children: [
  //     {
  //       path: 'house-calendar',
  //       component: () => import('@/views/calendar/house-calendar'),
  //       name: 'houseCalendar',
  //       meta: {
  //         perms: ['calendar.house'],
  //         title: '开拍房源日历',
  //         noCache: true
  //       },
  //     }
  //   ]
  // },
  {//运营管理
    path: '/operation',
    component: Layout,
    alwaysShow: true,
    redirect: '/operation/content',
    name: 'operationManage',
    meta: {
      title: '运营',
       icon: 'iconfont iconyunyingtuiguang'
    },
    children: [
      {
        path: 'content',
        component: () => import('@/views/operation/index'),
        name: 'Content',
        alwaysShow: true,
        meta: {
          perms: ['operate.news/index'],
          title: '文章管理'
        },
        children: [
          {
            path: 'article-list',
            component: () => import('@/views/operation/content/article/article-list'),
            name: 'articleList',
            meta: {
              perms: ['operate.news/list','operate.news/search','operate.news/add','operate.news/edit','operate.news/updown','operate.news/info'],
              title: '文章列表'
            }
          },
          {
            path: 'article-add',
            component: () => import('@/views/operation/content/article/article-add'),
            name: 'articleAdd',
            meta: {
              perms: ['operate.news/add'],
              title: '文章添加',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/content/article-list'
            },
            hidden: true
          },
          {
            path: 'article-edit',
            component: () => import('@/views/operation/content/article/article-add'),
            name: 'articleEdit',
            meta: {
              perms: ['operate.news/edit'],
              title: '文章编辑',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/content/article-list'
            },
            hidden: true
          },
          {
            path: 'article-info',
            component: () => import('@/views/operation/content/article/article-info'),
            name: 'articleInfo',
            meta: {
              perms: ['operate.news/info'],
              title: '查看文章',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/content/article-list'
            },
            hidden: true
          },
        ]
      },
      {
        path: 'business',
        component: () => import('@/views/operation/index'),
        name: 'Business',
        alwaysShow: true,
        meta: {
          perms: ['operate.business/index'],
          title: '业务管理'
        },
        children: [
          {
            path: 'manager-list',
            component: () => import('@/views/operation/business/manager/manager-list'),
            name: 'managerList',
            meta: {
              perms: ['operate.business/list','operate.business/search','operate.business/add','operate.business/edit','operate.business/info'],
              title: '法拍经理'
            }
          },
          {
            path: 'manager-add',
            component: () => import('@/views/operation/business/manager/manager-add'),
            name: 'managerAdd',
            meta: {
              perms: ['operate.business/add'],
              title: '添加法拍经理',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/business/manager-list'
            },
            hidden: true
          },
          {
            path: 'manager-edit',
            component: () => import('@/views/operation/business/manager/manager-add'),
            name: 'managerEdit',
            meta: {
              perms: ['operate.business/edit'],
              title: '编辑法拍经理',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/business/manager-list'
            },
            hidden: true
          },
          {
            path: 'manager-info',
            component: () => import('@/views/operation/business/manager/manager-info'),
            name: 'managerInfo',
            meta: {
              perms: ['operate.business/info'],
              title: '查看法拍经理',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/business/manager-list'
            },
            hidden: true
          },
        ]
      },
      {
        path: 'recommended',
        component: () => import('@/views/operation/index'),
        name: 'Recommended',
        alwaysShow: true,
        meta: {
          perms: ['operate.recommend/ndex'],
          title: '推荐管理'
        },
        children: [
          {
            path: 'house-mend',
            component: () => import('@/views/operation/recommended/house/house-mend'),
            name: 'houseMend',
            meta: {
              perms: ['operate.recommend/list','operate.recommend/jx','operate.recommend/jl','operate.recommend.jx/recomm','operate.recommend.jl/recomm','operate.recommend.jx/info','operate.recommend.jl/info'],
              title: '房产推荐'
            }
          },{
            path: 'auction-hot',
            component: () => import('@/views/operation/recommended/house/house-mend2'),
            name: 'auctionHot',
            meta: {
              perms: ['operate.hotlist/list','operate.hotlist/info','operate.hotlist/edit','operate.hotlist/replace','operate.hotlist/insert'],
              title: '拍卖热榜'
            }
          },

          // {
          //   path: 'auction-hot',
          //   component: () => import('@/views/operation/recommended/auction/auction-hot'),
          //   name: 'auctionHot',
          //   meta: {
          //     perms: ['operate.hotlist/list','operate.hotlist/info','operate.hotlist/edit','operate.hotlist/replace','operate.hotlist/insert'],
          //     title: '拍卖热榜'
          //   }
          // },
          {
            path: 'auction-hot-add',
            component: () => import('@/views/operation/recommended/auction/auction-hot-edit'),
            name: 'auctionHotAdd',
            meta: {
              perms: ['operate.hotlist/edit'],
              title: '添加拍卖热榜',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/recommended/auction-hot'
            },
            hidden: true
          },
          {
            path: 'auction-hot-edit',
            component: () => import('@/views/operation/recommended/auction/auction-hot-edit'),
            name: 'auctionHotEdit',
            meta: {
              perms: ['operate.hotlist/edit'],
              title: '修改拍卖热榜',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/recommended/auction-hot'
            },
            hidden: true
          },
          {
            path: 'auction-history-edit',
            component: () => import('@/views/operation/recommended/auction/auction-hot-edit'),
            name: 'auctionHistoryEdit',
            meta: {
              perms: ['operate.hotlist/edit'],
              title: '修改历史热榜',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/recommended/auction-hot'
            },
            hidden: true
          },
          {
            path: 'auction-hot-info',
            component: () => import('@/views/operation/recommended/auction/auction-hot-edit'),
            name: 'auctionHotInfo',
            meta: {
              perms: ['operate.hotlist/info'],
              title: '查看详情',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/recommended/auction-hot'
            },
            hidden: true
          },
        ]
      },
      {//素材管理
        path: 'fodder',
        component: () => import('@/views/operation/index'),
        alwaysShow: true,
        name: 'Fodder',
        meta: {
          perms: ['operate.material/index'],
          title: '素材管理'
        },
        children: [
          {
            path: 'fodder-list',
            component: () => import('@/views/operation/fodder/fodder-list'),
            name: 'fodderList',
            meta: {
              perms: ['operate.material/list','operate.material/add','operate.material/edit','operate.material/del','operate.material/info'],
              title: '素材列表',
              noCache: true
            },
          },
          {
            path: 'fodder-add',
            component: () => import('@/views/operation/fodder/fodder-add'),
            name: 'fodderAdd',
            meta: {
              perms: ['operate.material/add'],
              title: '添加素材',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/fodder/fodder-list'
            },
            hidden: true
          },
          {
            path: 'fodder-edit',
            component: () => import('@/views/operation/fodder/fodder-add'),
            name: 'fodderEdit',
            meta: {
              perms: ['operate.material/edit','operate.material/info'],
              title: '编辑素材',
              noCache: true,
              guidePath:true,
              jumpPath:'/operation/fodder/fodder-list'
            },
            hidden: true
          }
        ]
      },
      {//数据管理
        path: 'data',
        component: () => import('@/views/operation/index'),
        alwaysShow: true,
        name: 'Data',
        meta: {
          perms: ['operate.data/index'],
          title: '数据管理'
        },
        children: [
          {
            path: 'housing-list',
            component: () => import('@/views/operation/data/housing/housing-list'),
            name: 'fodderList',
            meta: {
              perms: ['operate.ershoufang/list','operate.ershoufang/search','operate.ershoufang/add','operate.ershoufang/edit'],
              title: '二手房数据',
              noCache: true
            },
          },
          {
            path: 'foreclosure-list',
            component: () => import('@/views/operation/data/foreclosure/foreclosure-list'),
            name: 'foreclosureList',
            meta: {
              perms: ['operate.fapaifang/list','operate.fapaifang/search','operate.fapaifang/add','operate.fapaifang/edit'],
              title: '法拍房数据',
              noCache: true
            },
          }
        ]
      }
    ]
  },
  {//人资管理
    path: '/human',
    component: Layout,
    redirect: '/human/ment',
    name: 'humanManage',
    alwaysShow: true,
    meta: {
      title: '人资',
      icon: 'iconfont iconxiaoshouguanli'
    },
    children: [
      {
        path: 'ment',
        component: () => import('@/views/human/index'),
        name: 'Ment',
        meta: {
          perms: ['human.department/index'],
          title: '部门管理'
        },
        alwaysShow: true,
        children:[
          {
            path: 'ment-list',
            component: () => import('@/views/human/ment/mentlist/ment-list'),
            name: 'mentList',
            meta: {
              perms: ['human.department/list','human.department/search','human.department/add','human.department/edit','human.department/info','human.department/adddepartment','human.department/del'],
              title: '部门列表',
              noCache: true
            }
          }
        ]
      },
      {
        path: 'staff',
        component: () => import('@/views/human/index'),
        name: 'Staff',
        meta: {
          perms: ['human.user/index'],
          title: '员工管理'
        },
        alwaysShow: true,
        children:[
          {
            path: 'staff-list',
            component: () => import('@/views/human/staff/stafflist/staff-list'),
            name: 'staffList',
            meta: {
              perms: ['human.user/list','human.user/search','human.user/add','human.user/edit','human.user/info','human.user/lizhi','human.user/leave','human.user/del'],
              title: '员工列表',
              noCache: true
            }
          }
        ]
      },
    ]
  },
  {//系统管理
    path: '/sys',
    component: Layout,
    redirect: '/sys/perms',
    alwaysShow: true,
    name: 'sysManage',
    meta: {
      title: '系统[CRM]',
      icon: 'iconfont iconxitong'
    },
    children: [
      {
        path: 'log-list',
        component: () => import('@/views/sys/log/logList'),
        name: 'logList',
        alwaysShow: true,
        meta: {
          perms: ['system.log/login'],
          title: '登录日志'
        },
      },
      {
        path: 'log-oplist',
        component: () => import('@/views/sys/log/oplogList'),
        name: 'oplogList',
        alwaysShow: true,
        meta: {
          perms: ['system.log/oper'],
          title: '操作日志'
        },
      },
      {
        path: 'notice-list',
        component: () => import('@/views/operation/content/notice/notice-list'),
        name: 'noticeList',
        meta: {
          perms: ['operate.notice/list'],
          title: '公告列表'
        }
      },
      {
        path: 'notice-add',
        component: () => import('@/views/operation/content/notice/notice-add'),
        name: 'noticeAdd',
        meta: {
          perms: ['operate.notice/add'],
          title: '公告添加',
          noCache: true,
          guidePath:true,
          jumpPath:'/operation/content/notice-list'
        },
        hidden: true
      },
      {
        path: 'notice-edit',
        component: () => import('@/views/operation/content/notice/notice-add'),
        name: 'noticeEdit',
        meta: {
          perms: ['operate.notice/edit'],
          title: '公告编辑',
          noCache: true,
          guidePath:true,
          jumpPath:'/operation/content/notice-list'
        },
        hidden: true
      },
    
      {
        path: 'msglist',
        component: () => import('@/views/sys/msg/MsgList'),
        name: 'msglist',
        alwaysShow: true,
        meta: {
          perms: ['system.msg/list'],
          title: '管理员消息通知'
        },
      },
      {
        path: 'datelist',
        component: () => import('@/views/sys/date/Date'),
        name: 'datelist',
        alwaysShow: true,
        meta: {
          perms: ['system.date/list'],
          title: '保护排除日期'
        },
      },

      {
        path: 'perms',
        component: () => import('@/views/sys/perms/index'), // Parent router-view
        name: 'Perms',
        alwaysShow: true,
        meta: {
          perms: ['system.auth/index'],
          title: '权限管理'
        },
        children: [
          {
            path: 'perms-role',
            component: () => import('@/views/sys/perms/role/perms-role'),
            name: 'permsRole',
            meta: {
              perms: ['system.authgroup/index','system.authgroup/listrole','system.authgroup/search','system.authgroup/addrole','system.authgroup/editrole','system.authgroup/delrole','system.authgroup/copy','system.authgroup/add','system.authgroup/list','system.authgroup/ruleinfo','system.authgroup/ruleedit','system.authgroup/datainfo','system.authgroup/dataedit'],
              title: '角色和权限',
              noCache: true
            }
          },
          {
            path: 'perms-role-part',
            component: () => import('@/views/sys/perms/role/perms-role-part'),
            name: 'permsRolePart',
            meta: {
              perms: ['system.authgroup/ruleinfo','system.authgroup/ruleedit'],
              title: '功能权限',
              noCache: true,
              guidePath:true,
              jumpPath:'/sys/perms/perms-role'
            },
            hidden: true
          },
          {
            path: 'perms-role-information',
            component: () => import('@/views/sys/perms/role/perms-role-information'),
            name: 'permsRoleInformation',
            meta: {
              perms: ['system.authgroup/datainfo','system.authgroup/dataedit'],
              title: '数据权限',
              noCache: true,
              guidePath:true,
              jumpPath:'/sys/perms/perms-role'
            },
            hidden: true
          },
          {
            path: 'perms-group',
            component: () => import('@/views/sys/perms/role/perms-group'),
            name: 'permsGroup',
            meta: {
              perms: ['system.authgroup/list','system.authgroup/list/search','system.authgroup/add','system.authgroup/edit','system.authgroup/info'],
              title: '权限组',
              noCache: true,
              guidePath:true,
              jumpPath:'/sys/perms/perms-role'
            },
            hidden: true
          },
          {
            path: 'perms-group-add',
            component: () => import('@/views/sys/perms/role/perms-group-add'),
            name: 'permsGroupAdd',
            meta: {
              perms: ['system.authgroup/add'],
              title: '添加权限组',
              noCache: true,
              guidePath:true,
              jumpPath:'/sys/perms/perms-role'
            },
            hidden: true
          },
          {
            path: 'perms-group-edit',
            component: () => import('@/views/sys/perms/role/perms-group-add'),
            name: 'permsGroupEdit',
            meta: {
              perms: ['system.authgroup/edit'],
              title: '编辑权限组',
              noCache: true,
              guidePath:true,
              jumpPath:'/sys/perms/perms-role'
            },
            hidden: true
          },
          {
            path: 'perms-group-info',
            component: () => import('@/views/sys/perms/role/perms-group-add'),
            name: 'permsGroupInfo',
            meta: {
              perms: ['system.authgroup/info'],
              title: '查看权限组',
              noCache: true,
              guidePath:true,
              jumpPath:'/sys/perms/perms-role'
            },
            hidden: true
          },
          {
            path: 'department-user',
            component: () => import('@/views/sys/perms/department/user'),
            name: 'departmentUser',
            meta: {
              perms: [
                'system.user/index',
                'system.user/list',
                'system.user/search',
                'system.user/add',
                'system.user/edit',
                'system.user/disable',
                'system.user/unlock'
              ],
              title: '部门和用户',
              noCache: true
            }
          }
        ]
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js